// extracted by mini-css-extract-plugin
export default {"cardContainer":"Card_cardContainer__nNDjI","cardChild":"Card_cardChild__Ndz6k"};